module.exports = __webpack_public_path__ + "static/media/kulianActive.42b8fb40.png";